/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import dayjs from "dayjs";
import { format } from "timeago.js";
import { FlexContainer, Text, theme } from "@nordcloud/gnui";
import { dateFormat } from "~/constants/dateFormats";

type Props = {
  value?: string | null;
};

export function DateCell({ value }: Props) {
  return (
    <FlexContainer
      justifyContent="flex-start"
      alignItems="flex-start"
      direction="column"
    >
      <div>{value && format(dayjs(value).toDate())}</div>
      <FlexContainer alignItems="center">
        <Text
          size="sm"
          tag="span"
          mr={theme.spacing.spacing01}
          weight="regular"
          color={theme.color.text.text02}
        >
          {value && dayjs(value).format(dateFormat.dayMonthYearHourMinute)}
        </Text>
      </FlexContainer>
    </FlexContainer>
  );
}
